import React from 'react';

export const PostSkeleton = () => {
  return (
    <div className="bg-white dark:bg-slate-800 rounded-[2rem] sm:rounded-[2.5rem] shadow-sm border border-slate-200/60 dark:border-slate-700/50 overflow-hidden mb-6 sm:mb-8 animate-pulse">
      <div className="p-4 flex items-center gap-3">
        <div className="h-10 w-10 rounded-full bg-slate-200 dark:bg-slate-700" />
        <div className="space-y-2">
          <div className="h-4 w-32 bg-slate-200 dark:bg-slate-700 rounded-md" />
          <div className="h-3 w-20 bg-slate-100 dark:bg-slate-800 rounded-md" />
        </div>
      </div>
      
      <div className="px-4 pb-3 space-y-2">
        <div className="h-4 w-full bg-slate-100 dark:bg-slate-800 rounded-md" />
        <div className="h-4 w-2/3 bg-slate-100 dark:bg-slate-800 rounded-md" />
      </div>

      <div className="aspect-square sm:aspect-video bg-slate-200 dark:bg-slate-700 sm:mx-4 sm:rounded-2xl mb-4" />

      <div className="p-4 flex gap-6 border-t border-slate-50 dark:border-slate-700/50">
        <div className="h-6 w-12 bg-slate-100 dark:bg-slate-800 rounded-full" />
        <div className="h-6 w-12 bg-slate-100 dark:bg-slate-800 rounded-full" />
      </div>
    </div>
  );
};
